var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLowSeverity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Oval Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A-Info",
    transform: "translate(-7.000000, -7.000000)",
    fill: "#C0D0D0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8919678,7.69471359 C9.54475759,7.69471359 7.64196777,9.59750341 7.64196777,11.9447136 C7.64196777,14.2919238 9.54475759,16.1947136 11.8919678,16.1947136 C14.239178,16.1947136 16.1419678,14.2919238 16.1419678,11.9447136 C16.1419678,9.59750341 14.239178,7.69471359 11.8919678,7.69471359 Z M11.8919678,9.19471359 C13.4107508,9.19471359 14.6419678,10.4259305 14.6419678,11.9447136 C14.6419678,13.4634967 13.4107508,14.6947136 11.8919678,14.6947136 C10.3731847,14.6947136 9.14196777,13.4634967 9.14196777,11.9447136 C9.14196777,10.4259305 10.3731847,9.19471359 11.8919678,9.19471359 Z",
    id: "Oval-Copy-2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowSeverity);
export default __webpack_public_path__ + "static/media/low-severity.786e38ca2e6c07f1ab02302abd766519.svg";
export { ForwardRef as ReactComponent };